import { useState } from 'react';
import type { ReactNode } from 'react';

interface SeccionColapsableProps {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
}

export function SeccionColapsable({ title, defaultOpen = true, children }: SeccionColapsableProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="sec-block">
      <div className="sec-hdr" onClick={() => setOpen(o => !o)}>
        <span className="sec-hdr-title">{title}</span>
        <span className={`sec-chev${open ? ' open' : ''}`}>⌄</span>
      </div>
      <div className={`sec-body${open ? ' open' : ''}`}>{children}</div>
    </div>
  );
}
